import {ActionType} from 'redux-promise-middleware';
import ExperimentUtils from 'utils/experiment';
import {USER_LOGIN, USER_LOGOUT, USER_UPDATE} from 'store/user/user-actions';
import {SEARCH_REQUEST_SET_TERM} from 'store/search-request/search-request-actions';

export const experimentMiddleware = ({getState}) => next => action => {
    const {payload, type} = action;

    switch (type) {
        case USER_UPDATE:
        case `${USER_LOGIN}_${ActionType.Fulfilled}`: {
            const storedUser = getState().user.data;
            const newUser = payload?.id && storedUser.id !== payload?.id;

            if (newUser) {
                ExperimentUtils.initUserAttributes(payload);
            }

            break;
        }

        case `${USER_LOGOUT}_${ActionType.Fulfilled}`: {
            ExperimentUtils.initUserAttributes();

            break;
        }

        case SEARCH_REQUEST_SET_TERM: {
            const {monthly} = payload;

            ExperimentUtils.setUserAttributes({
                monthly: Boolean(monthly).toString(),
            });

            break;
        }
    }

    return next(action);
};
